import api from './apiClient';

// Check if captions user exists in bjorn.users database
export const apiCheckBjornUser = async () => {
    try {
        const response = await api.get('/api/captions/check-bjorn-user');
        return response.data;
    } catch (error) {
        console.error('Error checking bjorn user:', error);
        return { exists: false, error: error.message };
    }
};

// Get decks for the bjorn user
export const apiGetBjornDecks = async (homeLanguage, targetLanguage) => {
    try {
        const params = {};
        if (homeLanguage) params.homeLanguage = homeLanguage;
        if (targetLanguage) params.targetLanguage = targetLanguage;

        const response = await api.get('/api/captions/bjorn-decks', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching bjorn decks:', error);
        throw error;
    }
};

// Check if a card exists in a deck
export const apiCheckBjornCard = async (deckId, word) => {
    try {
        const response = await api.get('/api/captions/bjorn-check-card', {
            params: { deckId, word }
        });
        return response.data;
    } catch (error) {
        console.error('Error checking card:', error);
        throw error;
    }
};

// Add a word to a bjorn deck
export const apiAddBjornWord = async (deckId, word, definition) => {
    try {
        const response = await api.post('/api/captions/bjorn-add-word', {
            deckId,
            word,
            definition
        });
        return response.data;
    } catch (error) {
        console.error('Error adding word:', error);
        throw error;
    }
};

// Create a new deck in bjorn
export const apiCreateBjornDeck = async (name, homeLanguage, targetLanguage) => {
    try {
        const response = await api.post('/api/captions/bjorn-create-deck', {
            name,
            homeLanguage,
            targetLanguage
        });
        return response.data;
    } catch (error) {
        console.error('Error creating deck:', error);
        throw error;
    }
};
